// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3eAnA","col":"Table_col__13Ihl","fulfillmentStatus":"Table_fulfillmentStatus__iwJkU","emailCol":"Table_emailCol__1sWhg"};